<template>
  <div
    id="smart-lead-card"
    :class="[activeTab === 'snoozed' ? 'snoozed' : null, isServiceClosed ? 'closed' : '']"
    @click="launchDetail()"
  >
    <div class="avatar-container">
      <img
        v-if="leadTitle?.includes('Water Detected')"
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/leads/leak-alerts-icon.svg"
      >
      <img
        v-else-if="leadTitle?.includes('Cool Runtime')"
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/leads/cooling-runtime-icon.svg"
      >
      <img
        v-else-if="leadTitle?.includes('Frozen Coil')"
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/leads/frozen-coil-icon.svg"
      >
      <img
        v-else-if="leadTitle?.includes('Discharge')"
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/leads/discharge-icon.svg"
      >
      <img
        v-else-if="leadTitle?.includes('Heat Runtime')"
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/leads/heating-daily-icon.svg"
      >
      <img
        v-else-if="leadTitle?.includes('Poor Heating Performance')"
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/leads/heating-perf-icon.svg"
      >
      <img
        v-else
        class="avatar-img"
        alt="avatar"
        src="@shared/assets/img/leads/poor-cooling-icon.svg"
      >
    </div>
    <div>
      <div class="grid-column jc-s gap-10">
        <button
          type="button"
          class="sac__font-16 f-white med underline"
          @click="navigateToProfile"
        >
          {{ customerName }}
        </button>
        <span
          v-if="serviceItem.planName"
          class="sac-tag n-80 size-10 r-4"
        >
          {{ serviceItem.planName }}
        </span>
        <span
          v-if="activeTab === ActionStatus.Closed.toLowerCase()"
          class="sac-tag n-80 size-10 r-4 t-upper"
        >
          {{ serviceItem.type }}
        </span>
      </div>
      <div class="sac__font-18 f-white semi-bold margin-top-8">
        {{ serviceAddress }}
      </div>
      <fragment v-if="isDetailView">
        <div class="sac__font-12 n20 med margin-top-4">
          {{ serviceItem.phone }}
        </div>
        <div class="sac__font-12 n20 med">
          {{ serviceItem.email }}
        </div>
      </fragment>
      <div class="grid-column ai-c jc-s gap-16 margin-top-8">
        <span
          v-if="leadTitle"
          class="sac-tag n-80 size-12 r-12 margin-right-8"
        >
          {{ leadTitle }}
        </span>
        <div v-if="ext.externalSource?.includes('titan')" class="external-tag">
          <img
            src="@shared/assets/img/general/service-titan-logo.svg"
            alt="logo"
            class="img-size-20"
          />
          <span
            class="sac__font-14 bold"
          >
            {{ ext.externalId }} <span v-if="ext.externalStatus">|</span>
          </span>
          <span
            v-if="ext.externalStatus"
            class="sac__font-14 med"
          >
            {{ ext.externalStatus }}
          </span>
        </div>
      </div>
    </div>
    <div class="sac__font-14 f-white semi-bold">
      <div v-if="hvacInfo">
        <div>
          {{ hvacInfo.firstItem }}
        </div>
        <div class="margin-top-8">
          {{ hvacInfo.secondItem }}
        </div>
        <div v-if="hvacInfo.bdrRating" class="margin-top-8">
          Breakdown Risk
          <span
            v-if="hvacInfo.bdrRating === 'High'"
            class="sac-tag-outline size-10 tomato r-8"
          >
            {{ hvacInfo.bdrRating }}
          </span>
          <span
            v-else-if="hvacInfo.bdrRating === 'Medium'"
            class="sac-tag-outline size-10 sunset r-8"
          >
            {{ hvacInfo.bdrRating }}
          </span>
          <span
            v-else
            class="sac-tag-outline size-10 basil r-8"
          >
            {{ hvacInfo.bdrRating }}
          </span>
        </div>
      </div>
      <div v-else class="sac__font-14 n60">
        HVAC info not available
      </div>
      <fragment v-if="isDetailView">
        <div class="sac__font-14 f-white bold margin-top-8">
          Zones:
          <span class="sac__font-14 f-white med">
            {{ serviceItem.systemName }}
          </span>
        </div>
        <div class="grid-column ai-c jc-s gap-10">
          <span>
            Comfort Credit Balance:
          </span>
          <img
            src="@shared/assets/img/general/loading-mini-white.svg"
            alt="Loading"
            v-if="loadingComfortCredit"
          >
          <span v-else>${{customerBalance || '--'}}</span>
        </div>
      </fragment>
    </div>
    <button
      type="button"
      class="sac-tag n-80 size-16 r-24 center"
      @click.stop="viewAllNotes(serviceItem)"
    >
      Notes
    </button>
    <div :class="['service-tag', isServiceClosed ? 'closed' : '']">
      <div class="grid-column jc-s align-center gap-10 hide-on-hover">
        <div class="tag-image-container">
          <img
            v-if="serviceItem.serviceStatus === ActionStatus.Snoozed"
            class="img-size-24"
            alt="Edit"
            src="@shared/assets/img/leads/bell.svg"
          >
          <img
            v-else-if="serviceItem.serviceStatus === ActionStatus.Dismissed"
            class="img-size-20"
            alt="Edit"
            src="@shared/assets/img/service/dismiss.svg"
          >
          <img
            v-else-if="serviceItem.serviceStatus === ActionStatus.Resolved"
            class="img-size-20"
            alt="Edit"
            src="@shared/assets/img/service/white-check.svg"
          >
          <img
            v-else-if="serviceItem.serviceStatus === ActionStatus.Expired"
            class="img-size-20"
            alt="Edit"
            src="@shared/assets/img/service/clock.svg"
          >
          <img
            v-else
            class="img-size-20"
            alt="Edit"
            src="@shared/assets/img/leads/siren.svg"
          >
        </div>
        <div>
          <div class="sac__font-18 semi-bold">
            {{ serviceTag.status }}
          </div>
          <div class="sac__font-14 med">
            {{ serviceTag.date }}
          </div>
        </div>
      </div>
      <div :class="['service-action-btns', activeTab === 'snoozed' ? 'grid-3' : '']">
        <button
          v-if="activeTab !== 'snoozed'"
          type="button"
          class="action-btn"
          @click.stop="handleAction('snooze-lead', ActionStatus.Snoozed)"
        >
          <img
            src="@shared/assets/img/service/snooze.svg"
            alt="action"
            class="img-size-24"
          >
          <span class="sac__font-8 semi-bold">Snooze</span>
        </button>
        <button
          type="button"
          class="action-btn"
          @click.stop="handleAction('dismiss-lead', ActionStatus.Dismissed)"
        >
          <img
            src="@shared/assets/img/service/white-x.svg"
            alt="action"
            class="img-size-24"
          >
          <span class="sac__font-8 semi-bold">Dismiss</span>
        </button>
        <button
          type="button"
          class="action-btn"
          @click.stop="handleAction('resolve', ActionStatus.Resolved)"
        >
          <img
            src="@shared/assets/img/service/white-check.svg"
            alt="action"
            class="img-size-24"
          >
          <span class="sac__font-8 semi-bold">Resolve</span>
        </button>
        <button
          type="button"
          class="action-btn"
          @click.stop="handleAction('new-service', ActionStatus.Scheduled)"
        >
          <img
            src="@shared/assets/img/service/calendar.svg"
            alt="action"
            class="img-size-24"
          >
          <span class="sac__font-8 semi-bold">Schedule</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import serviceMixin from '@shared/mixins/serviceMixin';
import ServiceReference from '@shared/lib/constant/ServiceReference';
import moment from 'moment';

export default {
  name: 'SmartLeadCard',
  mixins: [serviceMixin],
  props: {
    isDetailView: Boolean,
    serviceItem: Object,
  },
  computed: {
    customerName() {
      return this.serviceItem.customerName;
    },
    hvacInfo() {
      const {
        profileCompletedDate,
        manufacturer,
        systemAge,
        seer,
        eer,
        acSpeed,
        systemType,
        systemLocation,
        breakdownRiskRating,
      } = this.serviceItem;
      if (!profileCompletedDate) {
        return false;
      }
      let firstItem;
      if (manufacturer) {
        firstItem = `${manufacturer}`;
      }
      if (systemAge) {
        firstItem = `${firstItem} · ${systemAge} yrs `;
      }
      if (systemLocation?.toLowerCase() === 'ground' && eer) {
        firstItem = `${firstItem} · ${eer} EER`;
      } else if (seer) {
        firstItem = `${firstItem} · ${seer} SEER`;
      }

      let secondItem;
      if (acSpeed) {
        secondItem = `${acSpeed} Speed`;
      }
      if (systemType) {
        secondItem = `${secondItem} · ${systemType} System`;
      }

      return {
        firstItem,
        secondItem,
        bdrRating: breakdownRiskRating,
      };
    },
    serviceAddress() {
      const { serviceAddress } = this.serviceItem;
      return `${serviceAddress.address1}, ${serviceAddress.city}, ${serviceAddress.state} ${serviceAddress.zip}`;
    },
    leadTitle() {
      return this.serviceItem.title;
    },
    leadType() {
      return this.serviceItem.type;
    },
    isServiceClosed() {
      const {
        serviceStatus,
      } = this.serviceItem;
      return this.closedStatus.includes(serviceStatus);
    },
    ext() {
      const {
        externalId,
        externalSource,
        externalStatus,
      } = this.serviceItem;
      return {
        externalSource: externalSource?.toLowerCase(),
        externalId,
        externalStatus: this.formatExternalStatus(externalStatus),
      };
    },
    serviceTag() {
      const {
        actionStatusDate,
        serviceStatus,
        active,
        lastOccurred,
        startTime,
      } = this.serviceItem;
      let term;
      let date = lastOccurred || startTime || actionStatusDate;
      let status = serviceStatus;
      if (serviceStatus === 'New' && active) {
        status = 'Unresolved';
        term = 'From';
      } else if (serviceStatus === this.ActionStatus.Snoozed) {
        date = actionStatusDate;
        term = 'On';
      } else if (this.closedStatus.includes(serviceStatus)) {
        date = actionStatusDate;
        term = 'On';
      }

      date = moment(date).format('ll');
      return {
        status,
        date: `${term} ${date}`,
      };
    },
  },
  methods: {
    viewAllNotes(item) {
      this.setServiceReference();
      this.$store.dispatch('changeServiceValue', {
        field: 'serviceInfo',
        value: item,
      });
      this.toggleActionModal(true, 'view-all-notes');
    },
    setServiceReference() {
      this.$store.dispatch('changeServiceValue', {
        field: 'serviceReference',
        value: ServiceReference.LEAD,
      });
    },
    launchDetail() {
      this.setServiceReference();
      this.toggleServiceBottomSheet(true, 'smart-lead', this.serviceItem);
    },
    handleAction(modal, status) {
      const req = this.serviceItem;
      const actionReq = {
        actionStatus: status,
        alertNoticeId: req.alertNoticeId,
        customerId: req.customerId,
        customerName: req.customerName,
        serviceAddressId: req.serviceAddress.id,
        address: req.serviceAddress.address1,
        confirmedDate: null,
        confirmedTime: null,
        serviceCategory: null,
        serviceType: null,
        technicianId: null,
        corpId: req.corpId,
        corpName: req.corpName,
      };

      const changes = [{
        field: 'serviceInfo',
        value: this.serviceItem,
      }, {
        field: 'showActionModal',
        value: true,
      }, {
        field: 'actionModalView',
        value: modal,
      }, {
        field: 'actionRequest',
        value: actionReq,
      }];
      this.$store.dispatch('changeServiceValues', changes);
    },
  },
};
</script>

<style lang="scss" scoped>
#smart-lead-card {
  background: $N95;
  display: grid;
  grid-template-columns: 0.5fr 4fr 2fr 1fr 2fr;
  gap: 18px;
  padding: 24px;
  border-radius: 8px;
  margin-top: 24px;
  align-items: center;
  cursor: pointer;
  border-left: 8px solid $TOMATO200;
  &.closed {
    border-left: 8px solid $N40;
  }
  .avatar-container {
    height: 66px;
    width: 66px;
    display: grid;
    justify-content: center;
    align-content: center;
    border-radius: 33px;
    background: $N80;
    .avatar-img {
      width: 100%;
      height: 100%;
    }
  }
  .external-tag {
    display: grid;
    grid-auto-flow:  column;
    align-items: center;
    background-color: $WHITE;
    padding: 2px 12px;
    border-radius: 8px;
    gap: 8px;
  }
  .service-tag {
    position: relative;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 40px;
    background-color: $TOMATO200;
    max-width: 220px;
    color: $WHITE;
    display: grid;
    justify-self: flex-end;
    &.closed {
      background-color: $N50;
      color: $BLACK;
      pointer-events: none;
      cursor: none;
    }
    &:hover {
      display: grid;
      justify-items: center;
      border-radius: 8px;
      .service-action-btns {
        visibility: visible;
        opacity: 1;
      }
      .hide-on-hover {
        visibility: hidden;
      }
    }
    .tag-image-container {
      width: 40px;
      height: 40px;
      display: grid;
      justify-content: center;
      align-items: center;
      background: $BLACK;
      border-radius: 20px;
    }
    .service-action-btns {
      visibility: hidden;
      opacity: 0;
      transition: visibility 0ms, opacity 200ms linear;
      display: grid;
      align-items: center;
      justify-content: center;
      grid-auto-flow: column;
      position: absolute;
      top: 0;
      bottom: 0;
      right: -20px;
      border-radius: 8px;
      background-color: $TOMATO200;
      .action-btn {
        padding: 10px 12px;
        display: grid;
        font-size: 0.5rem;
        justify-items: center;
        gap: 2px;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
  &.snoozed {
    border-left: 8px solid $N80;
    .service-tag {
      background-color: $N80;
    }
    .service-action-btns {
      background-color: $N80;
    }
  }
}
</style>
